import { callApi } from '@local_modules/generic/fetch'
import { fillString } from '@local_modules/generic/string-template'

export async function testXeroConnection (accountingOrganisationId) {
  const urlEndpoint = '/api/connect-xero/:accountingOrganisationId/test-xero-connection'

  const url = fillString(urlEndpoint, {
    accountingOrganisationId
  })

  const response = await callApi(url, null, {
    method: 'GET'
  })

  showFeedback(accountingOrganisationId, response)

  return response
}

function showFeedback (entityId, apiResponse) {
  const feedbackElement = document.querySelector(`[d-type="feedback"][data-entity-id="${entityId}"]`)
  if (!feedbackElement) return

  if (apiResponse.receivedOrganisation?.organisationID) {
    feedbackElement.innerHTML = '<div class="tag is-success is-light">All Good</div>'
  } else {
    feedbackElement.innerHTML = '<div class="tag is-danger is-light">Error</div>'
  }
}
